export const transitions = {
  control:
    'background 150ms ease-out, box-shadow 150ms ease-out, color 150ms ease-out, fill 150ms ease-out, stroke 150ms ease-out, opacity 150ms ease-out, transform 150ms ease-out',
};
